module.exports = __webpack_public_path__ + "img/7-wall-cavity.31ce332c.svg";